var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDmr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 60,
    viewBox: "0 0 120 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M116.538 28.9155V26.607L115.637 26.0445H112.314L111.132 25.143H109.556L108.642 26.157L104.657 24.918L100.095 24.861L97.8991 23.904H96.7726L96.5476 25.0305H92.6056L91.3666 26.2125H75.2611V24.2415L74.0221 24.453V26.157L70.4146 25.932V22.722H68.7856L67.9411 22.074H65.9701V21.1455L67.7161 20.469L69.7426 20.8065L70.0426 16.977L68.9131 16.8645L67.6606 17.3715L66.9781 16.8645H65.9146L65.1826 16.245H61.5511L61.0156 15.6255H58.4536L57.9751 16.4985L56.2786 16.8645L57.1306 19.92L56.4541 20.5815L57.1306 21.651V22.5525C57.1306 22.5525 54.2026 23.2845 53.8081 23.2845H33.7036L33.3241 26.0445H32.2966L31.5076 28.1775L29.5201 28.245L28.5466 28.1055L27.3961 27.957L26.9461 28.5195H26.2141V27.225L25.2571 25.0845V19.4535H23.9626C23.9626 19.4535 23.9626 24.606 24.0886 24.8595C24.2146 25.113 23.6806 28.104 23.6806 28.104L22.7791 27.9555H21.2581L20.3566 28.659L16.4716 28.518L15.1771 27.3915H13.4881L12.6991 27.954H2.44961L2.22461 29.5305V30.7125H14.5576L16.6696 30.846L15.6841 32.5425L16.2376 33.5985L22.9486 33.6405L23.9626 34.1475L25.9336 34.197L27.2281 33.753H30.2686C31.0576 33.753 30.8071 34.3125 30.9016 34.7985C30.9961 35.2845 32.5636 35.526 32.5636 35.526L50.0326 38.142C50.0326 38.142 57.2956 38.0775 58.0846 38.067C58.8736 38.0565 60.4486 38.0445 61.2376 38.37C62.0266 38.6955 62.3236 40.392 62.3236 40.392C62.3236 40.392 64.3336 46.3095 64.7896 47.07C65.2456 47.8305 66.3391 47.985 67.1776 48.1725C68.0161 48.36 71.4346 47.904 71.4346 47.904L74.5261 47.6625L78.8386 46.2405L79.9396 45.579C79.9396 45.579 80.6086 43.665 80.3746 42.3195C80.1406 40.9755 79.1011 39.4875 78.9541 39.288C78.8071 39.0885 77.6251 38.145 77.5801 36.8295C77.5351 35.5125 79.8211 35.217 79.8211 35.217L81.9676 35.667L89.2246 45.5775H91.3651L92.7376 44.6205L93.8431 45.5775H108.597L109.386 43.494H110.343L110.906 44.733H113.046L113.919 44.001H115.412L116.538 43.494V41.2305L115.863 40.227V30.5415L116.538 28.908V28.9155ZM70.4146 34.8045C70.4146 34.8045 70.4041 34.956 70.5736 35.4195C70.7431 35.8845 70.5526 36.4575 70.5526 36.4575L71.5231 36.0315C71.5231 36.0315 72.4846 35.757 72.3466 36.771C72.2836 37.2315 71.2906 37.5735 71.2906 37.5735H68.4391L67.7221 34.8045H70.4131H70.4146ZM73.0021 46.6545C72.2206 46.7385 67.7866 47.0775 67.7866 47.0775C67.7866 47.0775 65.9701 46.9935 65.4211 45.6C64.8721 44.2065 62.8441 37.8705 62.8441 37.8705H63.5191L64.2796 38.9265L65.2936 38.8845L65.6731 37.575L66.3061 38.715L71.1631 38.757L72.1771 38.25L72.5146 39.222L71.9656 39.9825L72.2401 41.0805H73.0216L73.3591 42.0525L72.8521 42.6855L73.0636 43.8675C73.0636 43.8675 73.6126 43.8675 73.6966 44.2905C73.7806 44.7135 74.0341 45.8115 74.0341 45.8115C74.0341 45.8115 73.7806 46.572 72.9991 46.656L73.0021 46.6545Z",
    fill: "#FAFAFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4757 34.8044H103.247L103.811 35.5034V39.7829L102.797 41.5859H100.262L95.4757 38.8829V34.8044Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M105.388 31.4924L107.809 36.9119H114.229",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1816 26.2124H105.036V26.9309H103.6L102.333 28.9364H99.6086",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4375 38.1944L89.8445 35.6729H93.8435V39.6704L92.21 40.9379L90.218 38.1944H88.4375Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7383 41.3609L94.4348 40.1504L96.7718 41.3609V42.3254H92.7383V41.3609Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3867 34.4474V33.8564H81.9762L82.4832 33.2234H83.5812L84.8487 34.8044H88.2687L89.0712 33.6029H93.8442V35.6729",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8438 33.6029V31.4924",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7168 31.6814H60.4793",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M40.207 31.4924V26.5499",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7031 25.6214H40.2071L40.9661 25.1984H44.0501H47.4281V23.2844",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0498 23.2844V25.1984",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M40.207 28.9364H60.4795",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4795 30.6464H58.9165L58.156 29.8019H42.445L41.812 30.8519H40.207",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2423 32.7584L39.3613 33.3704L39.6358 33.9194L40.2058 33.9614L40.6708 33.5174L41.7268 33.7079L41.9593 34.3199L42.6343 34.4249L43.0348 34.0874L43.6258 34.2134L44.0488 34.8014H44.8513L45.0628 34.2134L54.6073 34.4459C54.6073 34.4459 56.2123 35.6714 57.3103 35.6714C58.4083 35.6714 59.0848 35.1644 59.0848 33.9404C59.0848 32.7164 57.7333 32.7584 57.7333 32.7584H33.3223V34.0679L49.7938 36.8339H54.4603C54.4603 36.8339 55.0093 36.7289 55.0093 36.2219C55.0093 35.7149 54.9433 34.6844 54.9433 34.6844",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6454 28.6619L66.9834 29.8019L68.3064 28.6619H65.6454Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6436 28.6619L71.9801 29.8019L73.3046 28.6619H70.6436Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6416 28.6619L76.9781 29.8019L78.3011 28.6619H75.6416Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6377 28.6619L81.9757 29.8019L83.2987 28.6619H80.6377Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6357 28.6619L86.9737 29.8019L88.2967 28.6619H85.6357Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7962 29.8019L89.4597 28.6619L88.1367 29.8019H90.7962Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7997 29.8019L84.4617 28.6619L83.1387 29.8019H85.7997Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M110.298 30.3719L108.961 29.2319L107.637 30.3719H110.298Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M105.138 29.2319L106.474 30.3719L107.799 29.2319H105.138Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M110.136 29.2319L111.472 30.3719L112.795 29.2319H110.136Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8016 29.8019L79.4636 28.6619L78.1406 29.8019H80.8016Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8036 29.8019L74.4671 28.6619L73.1426 29.8019H75.8036Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8055 29.8019L69.469 28.6619L68.1445 29.8019H70.8055Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6954 35.2229C76.6954 35.2229 76.2169 35.7584 76.0474 37.0529C75.8779 38.3474 76.8154 39.1319 77.6179 40.1504C78.6049 41.4014 79.9234 42.8189 78.5179 46.3514",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4757 35.6729H99.8677C99.8677 35.6729 101.078 35.6129 101.078 36.7109C101.078 37.6964 99.8962 37.7489 99.8962 37.7489H95.4757",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6583 17.3714V20.2154",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9688 20.9474V16.8644",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2384 16.4984V19.0754H58.4514V16.4984",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8429 20.3429C63.0765 20.3429 63.2659 20.1536 63.2659 19.9199C63.2659 19.6863 63.0765 19.4969 62.8429 19.4969C62.6093 19.4969 62.4199 19.6863 62.4199 19.9199C62.4199 20.1536 62.6093 20.3429 62.8429 20.3429Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M101.488 39.9104C101.829 39.9104 102.106 39.6338 102.106 39.2924C102.106 38.9511 101.829 38.6744 101.488 38.6744C101.147 38.6744 100.87 38.9511 100.87 39.2924C100.87 39.6338 101.147 39.9104 101.488 39.9104Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M2.44961 27.9585H12.6991L13.4881 27.396H15.1771L16.4716 28.5225H20.8081L21.2581 27.96H22.7791L23.6806 28.5225V27.678L23.9626 27.1155V19.4565H25.2571V25.0875L26.2141 27.228V28.5225H26.9461L27.3961 27.96H28.3531L29.0851 28.5225L29.7046 28.128L31.7311 28.185L32.2936 26.0445H33.7021V23.2845H54.1996L57.1276 22.5525V21.651L56.0011 21.2565V20.5815H58.2541V19.68H56.6776V18.159L56.1706 16.5255H58.2541V15.624H61.0141V16.2435H65.1811L65.9131 16.863H67.3216L67.6591 17.37L68.4481 16.9755H70.3066L69.7996 18.8895L69.7426 20.8035H68.4481L67.7161 20.466L67.2376 20.9445H65.9701V22.071H67.9411L68.7856 22.719H70.6441V26.154H74.0221V24.24H75.2611V26.211H91.3666L92.6056 25.029H96.5476V23.9025H97.8991L100.32 24.9165H104.657L108.824 26.211L109.556 25.1415H111.47L112.314 26.043H115.974L116.537 26.6055V28.914L115.862 30.5475V40.233L116.537 40.965V43.4985L115.41 44.0055H113.384V44.7375H110.906L110.343 43.4985H109.386V44.2305L108.597 45.582H93.6181L93.1111 44.85L93.8431 43.161H93.0541L91.8151 45.582H89.2246L83.0296 37.3035C83.0296 37.3035 81.6781 35.3325 80.7766 35.3325C79.8751 35.3325 78.9751 35.22 78.4681 35.502C77.9611 35.784 77.5111 36.4035 77.6791 37.3605C77.8486 38.3175 78.5236 38.5425 79.3681 39.894C80.2126 41.2455 80.6071 43.104 80.6071 43.6665C80.6071 44.229 80.1571 44.961 80.1571 44.961L79.8196 45.918L74.5261 47.664L68.2756 48.153C68.2756 48.153 65.1781 48.5085 64.3336 46.3125C63.4891 44.1165 61.9126 39.105 61.9126 39.105C61.9126 39.105 61.7986 37.9785 59.9971 38.0355C58.1956 38.0925 49.6921 38.148 49.6921 38.148L32.0101 35.445C32.0101 35.445 30.4336 35.445 30.8836 33.756H26.7721L26.0971 34.1505H23.9566L23.3941 33.6435H16.2991L15.6796 33.249V32.067L16.2421 31.56H16.6651V30.378H15.9046V30.7155H2.22461V29.5335H10.3336V28.971H2.39411L2.45111 27.957L2.44961 27.9585Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1788 38.2485L72.5163 39.2205L71.9673 39.981L72.2418 41.0789H73.0233L73.3608 42.051L72.8538 42.684L73.0653 43.866C73.0653 43.866 73.6143 43.866 73.6983 44.289C73.7823 44.712 74.0358 45.8099 74.0358 45.8099C74.0358 45.8099 73.7823 46.5705 73.0008 46.6545C72.2193 46.7385 67.7853 47.0775 67.7853 47.0775C67.7853 47.0775 65.9688 46.9935 65.4198 45.6C64.8708 44.2065 62.8428 37.8705 62.8428 37.8705H63.5178L64.2783 38.9265L65.2923 38.8845L65.6718 37.575L66.3048 38.715L71.1618 38.757L72.1758 38.25L72.1788 38.2485Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7235 34.8045L68.4405 37.5735H71.292C71.292 37.5735 72.285 37.2315 72.348 36.771C72.486 35.757 71.5245 36.0315 71.5245 36.0315L70.554 36.4575C70.554 36.4575 70.7445 35.8845 70.575 35.4195C70.4055 34.9545 70.416 34.8045 70.416 34.8045H67.725H67.7235Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7225 24.495L60.5355 23.847H65.829L66.8145 24.861H63.6045L63.2685 24.6645H61.4925L61.212 24.861H59.7225V24.495Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2009 23.2845V24.354H59.7224",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1805 24.861H70.644",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M65.97 22.074H57.129",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4802 37.6995V26.382H40.5032",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6444 26.157H63.6049V28.029L64.0279 28.62L63.9424 30.6465L63.6049 31.0695V32.2515H60.6484",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6045 32.2515H65.646V31.4925V31.1115H63.984",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6455 31.4925H114.792L113.046 26.382",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3662 26.2125V27.789H93.0552V29.2035H99.5877L100.602 30H102.966L104.262 28.107H108.711L108.823 26.2125",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4141 34.8044H82.8071L83.6516 35.8979H84.8906L91.3661 43.7819H92.7386",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8447 43.1625H102.629L103.193 42.3255H104.262L106.121 38.376H109.556V43.5",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M113.385 44.007C113.385 44.007 114.454 40.6845 114.454 40.515V31.491",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M16.668 30.3795H22.68V30.9435H26.397V30H27.7065V30.9435H29.142V31.7025H31.5075V30.5205H30.0705L28.9725 30H27.7065",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDmr);
export default __webpack_public_path__ + "static/media/DMR.556a8614b899c6268be296e5689148fa.svg";
export { ForwardRef as ReactComponent };